import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Ellipse2 = ({
  width = 121,
  height = 121,
  className,
  color,
  decorative = false,
  ariaLabel = "Ellipse",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 121 121"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <g fill="#fff" opacity="0.4">
        <ellipse
          cx="60.933"
          cy="2.194"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.933 2.194)"
        ></ellipse>
        <ellipse
          cx="52.534"
          cy="10.589"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 52.534 10.589)"
        ></ellipse>
        <ellipse
          cx="44.151"
          cy="18.979"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 44.151 18.98)"
        ></ellipse>
        <ellipse
          cx="35.761"
          cy="27.366"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.76 27.366)"
        ></ellipse>
        <ellipse
          cx="27.362"
          cy="35.761"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 27.362 35.76)"
        ></ellipse>
        <ellipse
          cx="18.972"
          cy="44.151"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 18.972 44.151)"
        ></ellipse>
        <ellipse
          cx="10.589"
          cy="52.542"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 10.589 52.542)"
        ></ellipse>
        <ellipse
          cx="56.737"
          cy="6.389"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.737 6.39)"
        ></ellipse>
        <ellipse
          cx="48.347"
          cy="14.78"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 48.347 14.78)"
        ></ellipse>
        <ellipse
          cx="39.948"
          cy="23.174"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.948 23.174)"
        ></ellipse>
        <ellipse
          cx="31.565"
          cy="31.565"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.565 31.565)"
        ></ellipse>
        <ellipse
          cx="23.167"
          cy="39.956"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 23.167 39.956)"
        ></ellipse>
        <ellipse
          cx="14.776"
          cy="48.346"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 14.776 48.346)"
        ></ellipse>
        <ellipse
          cx="6.394"
          cy="56.741"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 6.394 56.74)"
        ></ellipse>
        <ellipse
          cx="2.198"
          cy="60.932"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 2.198 60.932)"
        ></ellipse>
        <ellipse
          cx="93.878"
          cy="35.139"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 93.878 35.14)"
        ></ellipse>
        <ellipse
          cx="85.487"
          cy="43.53"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.487 43.53)"
        ></ellipse>
        <ellipse
          cx="77.089"
          cy="51.921"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 77.089 51.92)"
        ></ellipse>
        <ellipse
          cx="68.706"
          cy="60.311"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.706 60.311)"
        ></ellipse>
        <ellipse
          cx="60.308"
          cy="68.706"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.308 68.706)"
        ></ellipse>
        <ellipse
          cx="51.917"
          cy="77.096"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 51.917 77.096)"
        ></ellipse>
        <ellipse
          cx="43.526"
          cy="85.487"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.526 85.487)"
        ></ellipse>
        <ellipse
          cx="89.683"
          cy="39.335"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.683 39.335)"
        ></ellipse>
        <ellipse
          cx="81.292"
          cy="47.725"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 81.292 47.725)"
        ></ellipse>
        <ellipse
          cx="72.901"
          cy="56.116"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.901 56.116)"
        ></ellipse>
        <ellipse
          cx="64.511"
          cy="64.507"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.51 64.507)"
        ></ellipse>
        <ellipse
          cx="56.112"
          cy="72.901"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.112 72.901)"
        ></ellipse>
        <ellipse
          cx="47.722"
          cy="81.292"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 47.722 81.292)"
        ></ellipse>
        <ellipse
          cx="39.331"
          cy="89.682"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.331 89.682)"
        ></ellipse>
        <ellipse
          cx="35.136"
          cy="93.878"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.136 93.878)"
        ></ellipse>
        <ellipse
          cx="77.409"
          cy="18.667"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 77.41 18.667)"
        ></ellipse>
        <ellipse
          cx="69.011"
          cy="27.057"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 69.01 27.057)"
        ></ellipse>
        <ellipse
          cx="60.62"
          cy="35.448"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.62 35.448)"
        ></ellipse>
        <ellipse
          cx="52.23"
          cy="43.839"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 52.23 43.839)"
        ></ellipse>
        <ellipse
          cx="43.839"
          cy="52.233"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.839 52.233)"
        ></ellipse>
        <ellipse
          cx="35.448"
          cy="60.624"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.448 60.624)"
        ></ellipse>
        <ellipse
          cx="27.058"
          cy="69.014"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 27.058 69.014)"
        ></ellipse>
        <ellipse
          cx="73.206"
          cy="22.862"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 73.206 22.862)"
        ></ellipse>
        <ellipse
          cx="64.823"
          cy="31.253"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.823 31.253)"
        ></ellipse>
        <ellipse
          cx="56.425"
          cy="39.647"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.425 39.647)"
        ></ellipse>
        <ellipse
          cx="48.034"
          cy="48.034"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 48.034 48.034)"
        ></ellipse>
        <ellipse
          cx="39.636"
          cy="56.428"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.636 56.428)"
        ></ellipse>
        <ellipse
          cx="31.253"
          cy="64.819"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.253 64.82)"
        ></ellipse>
        <ellipse
          cx="22.862"
          cy="73.21"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 22.862 73.21)"
        ></ellipse>
        <ellipse
          cx="18.667"
          cy="77.405"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 18.667 77.405)"
        ></ellipse>
        <ellipse
          cx="110.347"
          cy="51.608"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 110.347 51.608)"
        ></ellipse>
        <ellipse
          cx="101.956"
          cy="60.003"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 101.956 60.003)"
        ></ellipse>
        <ellipse
          cx="93.565"
          cy="68.393"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 93.565 68.393)"
        ></ellipse>
        <ellipse
          cx="85.175"
          cy="76.784"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.175 76.784)"
        ></ellipse>
        <ellipse
          cx="76.784"
          cy="85.174"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 76.784 85.174)"
        ></ellipse>
        <ellipse
          cx="68.394"
          cy="93.569"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.394 93.57)"
        ></ellipse>
        <ellipse
          cx="60.003"
          cy="101.96"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.003 101.96)"
        ></ellipse>
        <ellipse
          cx="106.151"
          cy="55.807"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 106.151 55.807)"
        ></ellipse>
        <ellipse
          cx="97.761"
          cy="64.198"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 97.76 64.198)"
        ></ellipse>
        <ellipse
          cx="89.37"
          cy="72.589"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.37 72.589)"
        ></ellipse>
        <ellipse
          cx="80.98"
          cy="80.979"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 80.98 80.98)"
        ></ellipse>
        <ellipse
          cx="72.589"
          cy="89.37"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.589 89.37)"
        ></ellipse>
        <ellipse
          cx="64.198"
          cy="97.764"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.198 97.764)"
        ></ellipse>
        <ellipse
          cx="55.808"
          cy="106.155"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 55.808 106.155)"
        ></ellipse>
        <ellipse
          cx="51.612"
          cy="110.35"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 51.612 110.35)"
        ></ellipse>
        <ellipse
          cx="69.167"
          cy="10.432"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 69.167 10.432)"
        ></ellipse>
        <ellipse
          cx="60.776"
          cy="18.823"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.776 18.823)"
        ></ellipse>
        <ellipse
          cx="52.386"
          cy="27.214"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 52.386 27.214)"
        ></ellipse>
        <ellipse
          cx="43.995"
          cy="35.604"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.995 35.604)"
        ></ellipse>
        <ellipse
          cx="35.597"
          cy="43.999"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.597 43.999)"
        ></ellipse>
        <ellipse
          cx="27.206"
          cy="52.389"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 27.206 52.39)"
        ></ellipse>
        <ellipse
          cx="18.823"
          cy="60.78"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 18.823 60.78)"
        ></ellipse>
        <ellipse
          cx="64.972"
          cy="14.628"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.972 14.628)"
        ></ellipse>
        <ellipse
          cx="56.581"
          cy="23.018"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.581 23.018)"
        ></ellipse>
        <ellipse
          cx="48.19"
          cy="31.409"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 48.19 31.409)"
        ></ellipse>
        <ellipse
          cx="39.8"
          cy="39.8"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.8 39.8)"
        ></ellipse>
        <ellipse
          cx="31.401"
          cy="48.194"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.401 48.194)"
        ></ellipse>
        <ellipse
          cx="23.018"
          cy="56.585"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 23.018 56.585)"
        ></ellipse>
        <ellipse
          cx="14.628"
          cy="64.975"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 14.628 64.975)"
        ></ellipse>
        <ellipse
          cx="10.433"
          cy="69.171"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 10.433 69.17)"
        ></ellipse>
        <ellipse
          cx="102.112"
          cy="43.374"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 102.112 43.374)"
        ></ellipse>
        <ellipse
          cx="93.714"
          cy="51.764"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 93.714 51.764)"
        ></ellipse>
        <ellipse
          cx="85.323"
          cy="60.159"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.323 60.159)"
        ></ellipse>
        <ellipse
          cx="76.94"
          cy="68.546"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 76.94 68.546)"
        ></ellipse>
        <ellipse
          cx="68.542"
          cy="76.94"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.542 76.94)"
        ></ellipse>
        <ellipse
          cx="60.151"
          cy="85.331"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.151 85.33)"
        ></ellipse>
        <ellipse
          cx="51.769"
          cy="93.721"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 51.769 93.721)"
        ></ellipse>
        <ellipse
          cx="97.917"
          cy="47.569"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 97.917 47.57)"
        ></ellipse>
        <ellipse
          cx="89.526"
          cy="55.96"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.526 55.96)"
        ></ellipse>
        <ellipse
          cx="81.128"
          cy="64.354"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 81.128 64.354)"
        ></ellipse>
        <ellipse
          cx="72.745"
          cy="72.741"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.745 72.74)"
        ></ellipse>
        <ellipse
          cx="64.347"
          cy="81.135"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.347 81.135)"
        ></ellipse>
        <ellipse
          cx="55.956"
          cy="89.526"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 55.956 89.526)"
        ></ellipse>
        <ellipse
          cx="47.573"
          cy="97.917"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 47.573 97.917)"
        ></ellipse>
        <ellipse
          cx="43.37"
          cy="102.112"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.37 102.112)"
        ></ellipse>
        <ellipse
          cx="85.644"
          cy="26.901"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.644 26.901)"
        ></ellipse>
        <ellipse
          cx="77.253"
          cy="35.296"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 77.253 35.296)"
        ></ellipse>
        <ellipse
          cx="68.862"
          cy="43.686"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.862 43.686)"
        ></ellipse>
        <ellipse
          cx="60.472"
          cy="52.077"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.472 52.077)"
        ></ellipse>
        <ellipse
          cx="52.073"
          cy="60.468"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 52.073 60.468)"
        ></ellipse>
        <ellipse
          cx="43.683"
          cy="68.858"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.683 68.858)"
        ></ellipse>
        <ellipse
          cx="35.292"
          cy="77.253"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.292 77.253)"
        ></ellipse>
        <ellipse
          cx="81.448"
          cy="31.096"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 81.448 31.096)"
        ></ellipse>
        <ellipse
          cx="73.058"
          cy="39.491"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 73.058 39.49)"
        ></ellipse>
        <ellipse
          cx="64.667"
          cy="47.882"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.667 47.882)"
        ></ellipse>
        <ellipse
          cx="56.276"
          cy="56.272"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.276 56.272)"
        ></ellipse>
        <ellipse
          cx="47.878"
          cy="64.663"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 47.878 64.663)"
        ></ellipse>
        <ellipse
          cx="39.487"
          cy="73.057"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.487 73.057)"
        ></ellipse>
        <ellipse
          cx="31.097"
          cy="81.448"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.097 81.448)"
        ></ellipse>
        <ellipse
          cx="26.901"
          cy="85.639"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 26.901 85.64)"
        ></ellipse>
        <ellipse
          cx="118.581"
          cy="59.846"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 118.581 59.846)"
        ></ellipse>
        <ellipse
          cx="110.19"
          cy="68.237"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 110.19 68.237)"
        ></ellipse>
        <ellipse
          cx="101.8"
          cy="76.627"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 101.8 76.627)"
        ></ellipse>
        <ellipse
          cx="93.409"
          cy="85.018"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 93.41 85.018)"
        ></ellipse>
        <ellipse
          cx="85.019"
          cy="93.413"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.019 93.413)"
        ></ellipse>
        <ellipse
          cx="76.628"
          cy="101.803"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 76.628 101.803)"
        ></ellipse>
        <ellipse
          cx="68.237"
          cy="110.194"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.237 110.194)"
        ></ellipse>
        <ellipse
          cx="114.394"
          cy="64.042"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 114.394 64.042)"
        ></ellipse>
        <ellipse
          cx="105.995"
          cy="72.432"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 105.995 72.432)"
        ></ellipse>
        <ellipse
          cx="97.605"
          cy="80.823"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 97.605 80.823)"
        ></ellipse>
        <ellipse
          cx="89.214"
          cy="89.218"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.214 89.218)"
        ></ellipse>
        <ellipse
          cx="80.823"
          cy="97.608"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 80.823 97.608)"
        ></ellipse>
        <ellipse
          cx="72.433"
          cy="105.999"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.433 105.999)"
        ></ellipse>
        <ellipse
          cx="64.034"
          cy="114.389"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.034 114.389)"
        ></ellipse>
        <ellipse
          cx="59.847"
          cy="118.585"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 59.847 118.585)"
        ></ellipse>
        <ellipse
          cx="65.05"
          cy="6.315"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 65.05 6.315)"
        ></ellipse>
        <ellipse
          cx="56.659"
          cy="14.706"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.66 14.706)"
        ></ellipse>
        <ellipse
          cx="48.261"
          cy="23.096"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 48.26 23.096)"
        ></ellipse>
        <ellipse
          cx="39.878"
          cy="31.487"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.878 31.487)"
        ></ellipse>
        <ellipse
          cx="31.48"
          cy="39.878"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.48 39.878)"
        ></ellipse>
        <ellipse
          cx="23.089"
          cy="48.272"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 23.089 48.272)"
        ></ellipse>
        <ellipse
          cx="14.706"
          cy="56.659"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 14.706 56.659)"
        ></ellipse>
        <ellipse
          cx="60.855"
          cy="10.511"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.855 10.51)"
        ></ellipse>
        <ellipse
          cx="52.464"
          cy="18.897"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 52.464 18.897)"
        ></ellipse>
        <ellipse
          cx="44.073"
          cy="27.292"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 44.073 27.292)"
        ></ellipse>
        <ellipse
          cx="35.683"
          cy="35.682"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.683 35.682)"
        ></ellipse>
        <ellipse
          cx="27.284"
          cy="44.077"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 27.284 44.077)"
        ></ellipse>
        <ellipse
          cx="18.893"
          cy="52.468"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 18.893 52.468)"
        ></ellipse>
        <ellipse
          cx="10.511"
          cy="60.854"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 10.51 60.854)"
        ></ellipse>
        <ellipse
          cx="6.315"
          cy="65.053"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 6.315 65.053)"
        ></ellipse>
        <ellipse
          cx="97.995"
          cy="39.257"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 97.995 39.257)"
        ></ellipse>
        <ellipse
          cx="89.605"
          cy="47.647"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.605 47.647)"
        ></ellipse>
        <ellipse
          cx="81.206"
          cy="56.038"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 81.206 56.038)"
        ></ellipse>
        <ellipse
          cx="72.823"
          cy="64.432"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.823 64.432)"
        ></ellipse>
        <ellipse
          cx="64.425"
          cy="72.823"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.425 72.823)"
        ></ellipse>
        <ellipse
          cx="56.034"
          cy="81.214"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.034 81.214)"
        ></ellipse>
        <ellipse
          cx="47.644"
          cy="89.604"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 47.644 89.604)"
        ></ellipse>
        <ellipse
          cx="93.8"
          cy="43.452"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 93.8 43.452)"
        ></ellipse>
        <ellipse
          cx="85.409"
          cy="51.843"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.41 51.843)"
        ></ellipse>
        <ellipse
          cx="77.019"
          cy="60.233"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 77.019 60.233)"
        ></ellipse>
        <ellipse
          cx="68.628"
          cy="68.624"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.628 68.624)"
        ></ellipse>
        <ellipse
          cx="60.23"
          cy="77.018"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.23 77.018)"
        ></ellipse>
        <ellipse
          cx="51.847"
          cy="85.409"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 51.847 85.409)"
        ></ellipse>
        <ellipse
          cx="43.448"
          cy="93.799"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.448 93.8)"
        ></ellipse>
        <ellipse
          cx="39.253"
          cy="97.995"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.253 97.995)"
        ></ellipse>
        <ellipse
          cx="81.526"
          cy="22.784"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 81.526 22.784)"
        ></ellipse>
        <ellipse
          cx="73.128"
          cy="31.174"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 73.128 31.174)"
        ></ellipse>
        <ellipse
          cx="64.737"
          cy="39.569"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.737 39.57)"
        ></ellipse>
        <ellipse
          cx="56.347"
          cy="47.956"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.347 47.956)"
        ></ellipse>
        <ellipse
          cx="47.956"
          cy="56.35"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 47.956 56.35)"
        ></ellipse>
        <ellipse
          cx="39.565"
          cy="64.741"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.565 64.74)"
        ></ellipse>
        <ellipse
          cx="31.175"
          cy="73.132"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.175 73.132)"
        ></ellipse>
        <ellipse
          cx="77.323"
          cy="26.979"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 77.323 26.98)"
        ></ellipse>
        <ellipse
          cx="68.933"
          cy="35.37"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.933 35.37)"
        ></ellipse>
        <ellipse
          cx="60.542"
          cy="43.764"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.542 43.764)"
        ></ellipse>
        <ellipse
          cx="52.151"
          cy="52.151"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 52.151 52.151)"
        ></ellipse>
        <ellipse
          cx="43.761"
          cy="60.546"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.76 60.546)"
        ></ellipse>
        <ellipse
          cx="35.37"
          cy="68.936"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.37 68.936)"
        ></ellipse>
        <ellipse
          cx="26.98"
          cy="77.327"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 26.98 77.327)"
        ></ellipse>
        <ellipse
          cx="22.784"
          cy="81.522"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 22.784 81.522)"
        ></ellipse>
        <ellipse
          cx="114.464"
          cy="55.725"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 114.464 55.725)"
        ></ellipse>
        <ellipse
          cx="106.073"
          cy="64.116"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 106.073 64.116)"
        ></ellipse>
        <ellipse
          cx="97.675"
          cy="72.51"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 97.675 72.51)"
        ></ellipse>
        <ellipse
          cx="89.292"
          cy="80.901"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.292 80.901)"
        ></ellipse>
        <ellipse
          cx="80.894"
          cy="89.292"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 80.894 89.292)"
        ></ellipse>
        <ellipse
          cx="72.503"
          cy="97.682"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.503 97.682)"
        ></ellipse>
        <ellipse
          cx="64.112"
          cy="106.073"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.112 106.073)"
        ></ellipse>
        <ellipse
          cx="110.269"
          cy="59.921"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 110.269 59.92)"
        ></ellipse>
        <ellipse
          cx="101.878"
          cy="68.311"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 101.878 68.311)"
        ></ellipse>
        <ellipse
          cx="93.48"
          cy="76.706"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 93.48 76.706)"
        ></ellipse>
        <ellipse
          cx="85.097"
          cy="85.096"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.097 85.096)"
        ></ellipse>
        <ellipse
          cx="76.698"
          cy="93.491"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 76.698 93.49)"
        ></ellipse>
        <ellipse
          cx="68.308"
          cy="101.878"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.308 101.878)"
        ></ellipse>
        <ellipse
          cx="59.925"
          cy="110.272"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 59.925 110.272)"
        ></ellipse>
        <ellipse
          cx="55.73"
          cy="114.467"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 55.73 114.467)"
        ></ellipse>
        <ellipse
          cx="73.292"
          cy="14.55"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 73.292 14.55)"
        ></ellipse>
        <ellipse
          cx="64.894"
          cy="22.94"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.894 22.94)"
        ></ellipse>
        <ellipse
          cx="56.503"
          cy="31.331"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.503 31.33)"
        ></ellipse>
        <ellipse
          cx="48.112"
          cy="39.725"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 48.112 39.725)"
        ></ellipse>
        <ellipse
          cx="39.714"
          cy="48.116"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.714 48.116)"
        ></ellipse>
        <ellipse
          cx="31.331"
          cy="56.507"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.331 56.507)"
        ></ellipse>
        <ellipse
          cx="22.94"
          cy="64.897"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 22.94 64.897)"
        ></ellipse>
        <ellipse
          cx="69.097"
          cy="18.745"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 69.097 18.745)"
        ></ellipse>
        <ellipse
          cx="60.698"
          cy="27.136"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.698 27.136)"
        ></ellipse>
        <ellipse
          cx="52.308"
          cy="35.526"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 52.308 35.526)"
        ></ellipse>
        <ellipse
          cx="43.917"
          cy="43.917"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.917 43.917)"
        ></ellipse>
        <ellipse
          cx="35.519"
          cy="52.311"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.519 52.311)"
        ></ellipse>
        <ellipse
          cx="27.136"
          cy="60.702"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 27.136 60.702)"
        ></ellipse>
        <ellipse
          cx="18.737"
          cy="69.093"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 18.737 69.093)"
        ></ellipse>
        <ellipse
          cx="14.55"
          cy="73.288"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 14.55 73.288)"
        ></ellipse>
        <ellipse
          cx="106.229"
          cy="47.491"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 106.229 47.49)"
        ></ellipse>
        <ellipse
          cx="97.831"
          cy="55.882"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 97.831 55.882)"
        ></ellipse>
        <ellipse
          cx="89.44"
          cy="64.276"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.44 64.276)"
        ></ellipse>
        <ellipse
          cx="81.058"
          cy="72.663"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 81.058 72.663)"
        ></ellipse>
        <ellipse
          cx="72.659"
          cy="81.057"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.66 81.057)"
        ></ellipse>
        <ellipse
          cx="64.269"
          cy="89.448"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.269 89.448)"
        ></ellipse>
        <ellipse
          cx="55.886"
          cy="97.839"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 55.886 97.839)"
        ></ellipse>
        <ellipse
          cx="102.034"
          cy="51.686"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 102.034 51.686)"
        ></ellipse>
        <ellipse
          cx="93.644"
          cy="60.077"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 93.644 60.077)"
        ></ellipse>
        <ellipse
          cx="85.245"
          cy="68.471"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.245 68.471)"
        ></ellipse>
        <ellipse
          cx="76.862"
          cy="76.862"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 76.862 76.862)"
        ></ellipse>
        <ellipse
          cx="68.472"
          cy="85.253"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.472 85.253)"
        ></ellipse>
        <ellipse
          cx="60.073"
          cy="93.643"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.073 93.643)"
        ></ellipse>
        <ellipse
          cx="51.69"
          cy="102.034"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 51.69 102.034)"
        ></ellipse>
        <ellipse
          cx="47.495"
          cy="106.229"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 47.495 106.229)"
        ></ellipse>
        <ellipse
          cx="89.761"
          cy="31.022"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 89.76 31.022)"
        ></ellipse>
        <ellipse
          cx="81.37"
          cy="39.413"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 81.37 39.413)"
        ></ellipse>
        <ellipse
          cx="72.98"
          cy="47.803"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 72.98 47.803)"
        ></ellipse>
        <ellipse
          cx="64.581"
          cy="56.194"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 64.581 56.194)"
        ></ellipse>
        <ellipse
          cx="56.19"
          cy="64.585"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 56.19 64.585)"
        ></ellipse>
        <ellipse
          cx="47.8"
          cy="72.979"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 47.8 72.98)"
        ></ellipse>
        <ellipse
          cx="39.409"
          cy="81.37"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 39.41 81.37)"
        ></ellipse>
        <ellipse
          cx="85.565"
          cy="35.218"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 85.565 35.218)"
        ></ellipse>
        <ellipse
          cx="77.175"
          cy="43.608"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 77.175 43.608)"
        ></ellipse>
        <ellipse
          cx="68.784"
          cy="51.999"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 68.784 51.999)"
        ></ellipse>
        <ellipse
          cx="60.394"
          cy="60.389"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 60.394 60.39)"
        ></ellipse>
        <ellipse
          cx="51.995"
          cy="68.784"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 51.995 68.784)"
        ></ellipse>
        <ellipse
          cx="43.605"
          cy="77.174"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 43.605 77.174)"
        ></ellipse>
        <ellipse
          cx="35.214"
          cy="85.565"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 35.214 85.565)"
        ></ellipse>
        <ellipse
          cx="31.018"
          cy="89.76"
          rx="1.534"
          ry="1.563"
          transform="rotate(45 31.018 89.76)"
        ></ellipse>
      </g>
    </svg>
  );
};


